import { Component, HostListener, Input, OnInit } from '@angular/core';
import { socialFade } from 'src/app/animations/animation';
import { Article } from 'src/app/interfaces/article.interface';
import { Instagram } from 'src/app/interfaces/instagram.interface';
import { Menu } from 'src/app/interfaces/menu.interface';
import { WpapiService } from 'src/app/services/wpapi.service';

@Component({
    selector: 'app-home-article-instagram',
    templateUrl: './home-article-instagram.component.html',
    styleUrls: ['./home-article-instagram.component.scss'],
    animations: [socialFade]
})

export class HomeArticleInstagramComponent implements OnInit {
    articles: Article[] = [];
    instagrams: Instagram[] = [];
    filterinstagrams: Instagram[] = [];
    filtershowinstagrams: Instagram[] = [];
    socials: Menu[] = [];
    articlesplited: any;
    activeSlide: number;
    lastActive: number;
    interval;
    intervalinsta;
    width: number = 0;
    screenWidth: number = 0;
    isNotPaused: boolean = false;
    isNotPausedInsta: boolean = false;
    @Input() instagram: any;
    instaHidden: number = 10;
    animate: boolean = false;
    fadecontent: boolean = false
    labelwidth;
    instagramData: any;

    constructor(private wpApi: WpapiService) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit() {
        this.getArticles();
        this.getInstagram();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this.animate = false;
    }

    public onIntersection({ visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.articlesplited = this.chunkArray(this.articles, 2);
            this.fadecontent = true;
            this.animate = true;
            setTimeout(() => {
                this.activeSlide = 0;
            }, 100);
            setTimeout(() => {
                this.lastActive = 0;
            }, 400);
            this.isNotPaused = true;
        } else {
            this.isNotPaused = false;
        }
    }

    onIntersectionInstagram({ visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            if (this.filtershowinstagrams.length < 1) {
                var instafeed = this.instagram;
                const instaitems = instafeed.getElementsByClassName("sbi_item");
                for (let index = 0; index < instaitems.length; index++) {
                    const element = instaitems[index];
                    const href = element.getElementsByClassName('sbi_photo')[0].getAttribute('href');
                    const img = element.getElementsByTagName('img')[0].getAttribute('src');
                    const title = element.getElementsByClassName('sbi-screenreader')[0].innerHTML;
                    const alt = element.getElementsByTagName('img')[0].getAttribute('alt');
                    this.instagrams.push({
                        href: href,
                        img: img,
                        title: title,
                        alt: alt
                    });
                }
                this.loadRandomInstaPosts();
            }
            this.isNotPausedInsta = true;
        } else {
            this.isNotPausedInsta = false;
        }
    }

    loadRandomInstaPosts() {
        for (var i = 0; this.filterinstagrams.length < 8; i++) {
            var rand = this.instagrams[Math.floor(Math.random() * this.instagrams.length)];
            if (!this.containsObject(rand, this.filterinstagrams)) {
                this.filterinstagrams.push({
                    href: rand.href,
                    img: rand.img,
                    title: rand.title,
                    alt: rand.alt
                });
            }
        }
        this.filtershowinstagrams = this.filterinstagrams;
        this.intervalinsta = setInterval(() => {
            if (this.isNotPausedInsta) {
                var rand = this.instagrams[Math.floor(Math.random() * this.instagrams.length)];
                var index = Math.floor(Math.random() * 7);
                if (!this.containsObject(rand, this.filtershowinstagrams)) {
                    this.instaHidden = index;
                    setTimeout(() => {
                        this.filtershowinstagrams.splice(index, 1, rand);
                        this.instaHidden = 10;
                    }, 600);
                }
            }
        }, 8000)
    }

    containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].href === obj.href) {
                return true;
            }
        }
        return false;
    }

    getInstagram() {
        this.wpApi.getSocialMenu().subscribe(resp => {
            this.handleInstaResp(resp);
        });
    }

    getArticles() {
        this.wpApi.getArticles().subscribe(resp => {
            this.handleReponse(resp);
        })
    }

    chunkArray(arr, n) {
        var chunkLength = Math.max(arr.length / n, 2);
        var chunks = [];
        for (var i = 0; i < n; i++) {
            if (chunkLength * (i) <= arr.length) chunks.push(arr.slice(chunkLength * i, chunkLength * (i + 1)));
        }
        return chunks;
    }

    handleInstaResp(resp) {
        for (let i = 0; i < resp.items.length; i++) {
            const social = resp.items[i];
            if (social.title == "Instagram") {
                this.instagramData = social;
            }
        }
    }

    handleReponse(resp) {
        this.articles = resp;
        if (this.screenWidth > 1024) {
            this.labelwidth = 150 / this.articles.length;
        } else {
            this.labelwidth = 150 / this.articles.length;
        }
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                if (this.width >= 100) {
                    this.width = 0;
                    this.callBackSlide();
                } else {
                    this.width++;
                }
            }
        }, 150);
    }

    callBackSlide() {
        this.activeSlide++;
        if (this.screenWidth > 1024) {
            if (this.activeSlide >= this.articlesplited.length) {
                this.activeSlide = 0;
            }
        } else {
            if (this.activeSlide >= this.articles.length) {
                this.activeSlide = 0;
            }
        }
        setTimeout(() => {
            this.lastActive++;
            if (this.screenWidth > 1024) {
                if (this.lastActive >= this.articlesplited.length) {
                    this.lastActive = 0;
                }
            } else {
                if (this.lastActive >= this.articles.length) {
                    this.lastActive = 0;
                }
            }
        }, 300);
    }

    activeSlideDots(i) {
        this.activeSlide = i;
        if (this.screenWidth > 1024) {
            if (this.activeSlide >= this.articlesplited.length) {
                this.activeSlide = 0;
            }
        } else {
            if (this.activeSlide >= this.articles.length) {
                this.activeSlide = 0;
            }
            if (this.activeSlide < 0) {
                this.activeSlide = this.articles.length - 1;
            }
        }
        setTimeout(() => {
            this.lastActive = i;
            if (this.screenWidth > 1024) {
                if (this.lastActive >= this.articlesplited.length) {
                    this.lastActive = 0;
                }
            } else {
                if (this.lastActive >= this.articles.length) {
                    this.lastActive = 0;
                }
                if (this.lastActive < 0) {
                    this.lastActive = this.articles.length - 1;
                }
            }
        }, 300);
        this.width = 0;
    }

    onSwipeLeft() {
        if (this.screenWidth <= 1024) {
            var nextSlide = this.activeSlide + 1;
            this.activeSlideDots(nextSlide);
        }
    }

    onSwipeRight() {
        if (this.screenWidth <= 1024) {
            var prevSlide = this.activeSlide - 1;
            this.activeSlideDots(prevSlide);
        }
    }
}
